import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DataImportDetailPage } from '@/pages/data-imports/ui/DataImportDetailPage';
import { amountUnitValues } from '@/shared/lib/amount/convertAmount';
import { paginationSchema, routeValidateQuerySearch } from '@/shared/lib/route';

/**
 * EUCデータ詳細ルートの検索パラメータスキーマ
 *
 * - page: ページ番号
 * - page_size: ページサイズ
 * - query_store_id: QueryStore ID（検索条件保存用）
 * - amount_unit: 金額単位（円/千円）
 */
const dataImportDetailSearchSchema = paginationSchema.extend({
  query_store_id: z.string().optional(),
  amount_unit: z.enum(amountUnitValues).optional(),
});

export const Route = createFileRoute('/_protected/data-import/$importId/')({
  component: DataImportDetailPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: true,
      withPaginationSchema: dataImportDetailSearchSchema,
      defaultValues: undefined,
    }),
});
